import { Component, OnInit, TemplateRef, inject } from '@angular/core';
import { DialogOverlayRef } from '@app/core/classes/dialog.ref';
import { zoomInOnEnterAnimation, zoomOutOnLeaveAnimation } from 'angular-animations';
import { NgTemplateOutlet, NgComponentOutlet } from '@angular/common';

// export class DynamicDialogConfig {
// 	data?: any;
// 	header?: string;
// 	footer?: string;
// 	width?: string;
// 	height?: string;
// 	closeOnEscape?: boolean;
// 	baseZIndex?: number;
// 	dismissableMask?: boolean;
// 	style?: any;
// 	contentStyle?: any;
// 	styleClass?: string;
// 	transitionOptions?: string;
// 	closable?: boolean;
// 	showHeader?: boolean;
// 	modal?: boolean;
// }

@Component({
    selector: 'jeopardy-dynamicdialog',
    templateUrl: './dynamicdialog.component.html',
    styleUrls: ['./dynamicdialog.component.scss'],
    animations: [
        zoomInOnEnterAnimation(),
        zoomOutOnLeaveAnimation(),
    ],
    imports: [NgTemplateOutlet, NgComponentOutlet]
})
export class DynamicdialogComponent implements OnInit {
  contentType: 'template' | 'string' | 'component' = 'component';
  content: any;
  context: any;
  zoomInDuration: number;
  zoomOutDuration: number;
  
  private overlayRef = inject(DialogOverlayRef);

  ngOnInit(): void {
    this.zoomInDuration = 200;
    this.zoomOutDuration = 200;

    this.content = this.overlayRef.content;

    if(typeof this.content === 'string') {
      this.contentType = 'string';
    } else if(this.content instanceof TemplateRef) {
      this.contentType = 'template';
      this.context = {
        close: this.overlayRef.close.bind(this.overlayRef)
      }
    } else {
      this.contentType = 'component';
    }
  }

  close() {
    this.overlayRef.close(null);
  }

}
